__turbopack_context__.v({
  "dropdownMenuItem": "dropdown-menu-item-module-scss-module__L5cZxW__dropdownMenuItem",
  "selectable": "dropdown-menu-item-module-scss-module__L5cZxW__selectable",
  "selected": "dropdown-menu-item-module-scss-module__L5cZxW__selected",
  "u-animation-bounce": "dropdown-menu-item-module-scss-module__L5cZxW__u-animation-bounce",
});
